import type { ComponentType } from 'react';
import type {
  InsightListData,
  InsightRenderer,
  JourneyTimelineData,
  NarrativeBlockData,
  NumberedInsightListData,
} from '../types';
import JourneyTimelineRenderer from '../components/renderers/JourneyTimelineRenderer';
import InsightListRenderer from '../components/renderers/InsightListRenderer';
import NumberedInsightListRenderer from '../components/renderers/NumberedInsightListRenderer';
import NarrativeBlockRenderer from '../components/renderers/NarrativeBlockRenderer';

export const insightRendererMap: Record<
  InsightRenderer,
  ComponentType<{ data: any }>
> = {
  journeyTimeline: JourneyTimelineRenderer as ComponentType<{ data: JourneyTimelineData }>,
  insightList: InsightListRenderer as ComponentType<{ data: InsightListData }>,
  numberedInsightList: NumberedInsightListRenderer as ComponentType<{
    data: NumberedInsightListData;
  }>,
  narrativeBlock: NarrativeBlockRenderer as ComponentType<{ data: NarrativeBlockData }>,
};
